// Florida International University's undergraduate majors (#2743). Read on
// 2026-10-01 from the official 2026-2027 University Catalog's Programs list
// (catalog.fiu.edu/programs, a Coursedog page; the list was read from the
// catalog's own program search, which the page loads: active programs shown
// in the catalog). Every major whose degree is a bachelor's is kept (BA, BS,
// BBA, BFA, BM, BSN, BACC, BHSA, BPPA), named without its "Bachelor of ... in"
// prefix; minors, certificates and graduate and accelerated master's programs
// are left out. Groups are the catalog's colleges and schools, named as its
// Colleges, Schools and Departments page names them. The six BSN entries are
// the catalog's own BSN programs (traditional, accelerated, RN to BSN and
// others). Quirk: "Applied AI & Internet of Things" is the catalog's official
// name. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "florida-international-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in FIU's official 2026-2027 University Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts, Sciences, and Education",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Earth Science",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English Education",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Exceptional Student Education",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Natural and Applied Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Rehabilitation and Recreational Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Sport and Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Sport and Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability and the Environment",
                    "degree": "BA"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BACC"
                },
                {
                    "name": "Business Analytics and Artificial Intelligence",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BBA"
                },
                {
                    "name": "Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Logistics and Supply Chain Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "College of Communication, Architecture, and the Arts",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Communication Arts",
                    "degree": "BA"
                },
                {
                    "name": "Digital Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Digital Communication and Media",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Public Relations and Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Engineering and Computing",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Applied AI & Internet of Things",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science and Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BA"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Nicole Wertheim College of Nursing and Health Sciences",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Health Services Administration",
                    "degree": "BHSA"
                },
                {
                    "name": "Nursing - Accelerated Option Program",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Foreign Educated Physician",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - RN to BSN Program",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - RN to BSN/MSN Combined Degree Pathway",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Traditional Program",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Veterans Medic to BSN Program",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Robert Stempel College of Public Health and Social Work",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Dietetics and Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Disaster Management",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Chaplin School of Hospitality and Tourism Management",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Global Sustainable Tourism",
                    "degree": "BA"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Steven J. Green School of International and Public Affairs",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Crime Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Global Languages, Cultures, and Literatures",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy and Administration",
                    "degree": "BPPA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Adam Smith Center for Economic Freedom",
            "source": {
                "label": "FIU 2026-2027 University Catalog, Programs",
                "url": "https://catalog.fiu.edu/programs"
            },
            "majors": [
                {
                    "name": "Business and Government Leadership",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
